<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H36tDX/images/frontcoverjpg_highres3614250.jpg?1685790846979" alt="This image is the cover for the book Twenty-Eight and a Half Wishes, Rose Gardner Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twenty-Eight and a Half Wishes, Rose Gardner Mystery
      </h1>
      <p class="bookDescription body article font2">
        <p>For Rose Gardner, working at the DMV on a Friday afternoon is bad even before she sees a vision of herself dead. She’s had plenty of visions, usually boring ones like someone’s toilet’s overflowed, but she’s never seen one of herself before. When her overbearing momma winds up murdered on her sofa instead, two things are certain: There isn't enough hydrogen peroxide in the state of Arkansas to get that stain out, and Rose is the prime suspect.<br/><br/>Rose realizes she’s wasted twenty-four years of living and makes a list on the back of a Wal-Mart receipt: twenty-eight things she wants to accomplish before her vision comes true. She’s well on her way with the help of her next door neighbor Joe, who has no trouble teaching Rose the rules of drinking, but won’t help with number fifteen-- do more with a man. Joe’s new to town, but it doesn’t take a vision for Rose to realize he’s got plenty secrets of his own.<br/><br/>Somebody thinks Rose has something they want and they’ll do anything to get it. Her house is broken into, someone else she knows is murdered, and suddenly, dying a virgin in the Fenton County jail isn’t her biggest worry after all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Grover Swank
      </h2>
      
      <p class="authorDescription body article"><i>New York Times</i> and <i>USA Today</i> bestselling author Denise Grover Swank has released over thirty novels and novellas and has sold over two million books. She writes mysteries with romance, humorous romance, light-hearted young adult romance, and urban fantasy. She lives in Blue Springs, Missouri with her three naughty dogs and six imaginative children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      DGS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1724a6fa